import { render, staticRenderFns } from "./AddApplication.vue?vue&type=template&id=1247d70e&scoped=true"
import script from "./AddApplication.vue?vue&type=script&lang=ts"
export * from "./AddApplication.vue?vue&type=script&lang=ts"
import style0 from "./AddApplication.vue?vue&type=style&index=0&id=1247d70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1247d70e",
  null
  
)

export default component.exports